(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-button"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const floatingButton = document.querySelector('.floating-button');
    const footer = document.querySelector('footer, [id*="footer"], [class*="footer"]');
    
    if (!floatingButton || !footer) return;

    function checkFooterVisibility() {
      const footerRect = footer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Hide button when footer is visible in viewport
      if (footerRect.top < windowHeight) {
        floatingButton.classList.add('hidden');
      } else {
        floatingButton.classList.remove('hidden');
      }
    }

    // Check on scroll
    window.addEventListener('scroll', checkFooterVisibility);
    
    // Check initially
    checkFooterVisibility();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
